import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import StatusBadges from '@components/badges/StatusBadges';
import TableSearchInputGroup from '@components/smartAdminUI/input/TableSearchInputGroup';
import AgentActionButtons from './actionButtons/AgentActionButtons';
import DataTable from '../dataTable';
import translateColumns from '../dataTable/dataTranslate';

const AgentsTable = ({
  displayData,
  onAgentSelect,
  onAuditClick,
  isModal = false,
}) => {
  // NOTE: P9 mentioned that isCopiable will always be false so its not included
  const actionsFormatter = (cell, row) => (
    <AgentActionButtons
      viewClicked={onAgentSelect}
      auditClicked={onAuditClick}
      currRow={row}
      isEditable={row?.isEditable}
      isAuditable={row?.isAuditable}
    />
  );

  const hdrSortClasses = (_column, sortOrder) => `sorting_${sortOrder}`;

  const columns = [
    {
      dataField: 'actions',
      text: '',
      formatter: actionsFormatter,
      headerStyle: { width: '100px' },
    },
    {
      dataField: 'UniqueID',
      text: 'ID',
      hidden: true,
    },
    {
      dataField: 'MemberMlsId',
      text: 'MLS ID',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'MemberStatus',
      text: 'Status',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
      align: 'center',
      headerStyle: { width: '70px' },
      formatter: cellContent => (isEmpty(cellContent) ? '' : <StatusBadges status={cellContent} />),
    },
    {
      dataField: 'MemberFirstName',
      text: 'First Name',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'MemberLastName',
      text: 'Last Name',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'OfficeName',
      text: 'Office Name',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'OfficePhone',
      text: 'Office Phone',
    },
  ];

  const newCols = useMemo(() => translateColumns(columns), [columns]);

  return (
    <>
      <DataTable
        defaultSorted={[{ id: 'OfficeName', desc: true }]}
        columns={newCols}
        sizePerPage={isModal ? 5 : 10}
        data={displayData}
        wrapperClasses="table-responsive"
        id="agentsTable"
        noDataIndication="Your search returned no results. Please try adjusting your search criteria."
        classes="dataTable"
        striped
        hover
        searchComponent={searchProps => <TableSearchInputGroup {...searchProps} />}
      />
    </>
  );
};

AgentsTable.propTypes = {
  displayData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onAgentSelect: PropTypes.func.isRequired,
  onAuditClick: PropTypes.func.isRequired,
  isModal: PropTypes.bool,
};

export default AgentsTable;
